import { render, staticRenderFns } from "./IpsSidebar.vue?vue&type=template&id=10fdeeb8&scoped=true"
import script from "./IpsSidebar.vue?vue&type=script&lang=js"
export * from "./IpsSidebar.vue?vue&type=script&lang=js"
import style0 from "./IpsSidebar.vue?vue&type=style&index=0&id=10fdeeb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fdeeb8",
  null
  
)

export default component.exports